// src/app/features/leverage/leverageApi.js
import http from "../../api/http.js";

export async function getLeverageEligibility(asset = "USDT", network = "MAINNET") {
  const res = await http.get("/leverage/eligibility", { params: { asset, network } });
  return res.data;
}

export async function getMyLeverage() {
  const res = await http.get("/leverage/me");
  return res.data;
}

export async function requestLeverage({ asset = "USDT", network = "MAINNET" }) {
  const res = await http.post("/leverage/requests", { asset, network });
  return res.data;
}

// Admin
export async function adminListLeverageRequests(params = {}) {
  const res = await http.get("/admin/leverage/requests", { params });
  return res.data;
}

export async function adminDecideLeverageRequest(requestId, { approve, reason }) {
  const res = await http.post(`/admin/leverage/requests/${requestId}/decide`, { approve, reason });
  return res.data;
}
